import axios from "axios";
import React, { useRef } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import fundo from "../../../../styles/fundo.svg";
import Swal from "sweetalert2";
import './style.css';


const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  justify-content: center;
  align-items: flex-start;
  flex-direction: row;
  box-shadow: 0px 0px 2px #ccc;

`;

const DivContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: row;

`;



const DivButtons = styled.div`
  max-width:100%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 5px 0px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
`;





const InputArea = styled.div`
  width: auto;
  height: auto; 
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 10px;
  justify-content: center;

  select {
    width: 200px;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0px 10px;
    background-color: #f4f4f5;
    font-size: 16px;
    color: #3a3f42;
  }
  
`;




const Input = styled.input`
  width: 170px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  font-size: 16px;
  color: #3a3f42;
`;



const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  margin: 0px 5px;
  padding: 0px 0px 0px 10px; 


`;

const Button = styled.button`
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 5px 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: 20px;
  gap: 5px;
  transition: transform 0.3s;
  border: 1px solid #ccc;
  border-radius: 10px;
    &:hover {
    transform: scale(1.01);
    box-shadow: 0 4px 6px gray;
  }

`;









const Form = ({ editarCartao, urlApi, modalMover, colunas, fetchColunas, modalEditarCartao }) => {



  //Token da api
  const token = localStorage.getItem('token');
  const id = parseInt(localStorage.getItem('id'));

  //---------------------------------------------------------------------------//
  //Recebe os valores para editar, tipo onEdit
  const ref = useRef();


  //---------------------------------------------------------------------------//
  //Filtra as tarefas
  const colunasFiltradas = colunas.filter(v => v.ID_QUADRO === editarCartao.ID_QUADRO);
  const colunaAtual = colunasFiltradas.find(v => v.ID_LISTA === editarCartao.ID_LISTA);
  const colunasRestantes = colunasFiltradas.filter(v => v.ID_LISTA !== colunaAtual?.ID_LISTA);

  //---------------------------------------------------------------------------//
  //Delete as tarefas
  const handleSave = async () => {
    const user = ref.current;


    const id_colunaValue = user.id_coluna.value;
    const userConfirmed = await showPopUp();

    if (!userConfirmed) {
      return;
    }

    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.put(
        `${urlApi}painel-monitoramento/mudando-cartao-de-lista/${editarCartao.ID_CARTAO}`,
        { id_coluna: id_colunaValue },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      fetchColunas();
      toast.success("Cartão movido com sucesso.");
      setTimeout(function () {
        modalMover();
        modalEditarCartao();
      }, 1000);



    } catch (error) {
      // Tratamento de erros
      console.error('Erro ao deletar o usuário:', error);

      let errorMessage = 'Erro desconhecido ao deletar.';
      if (error.response) {
        errorMessage = error.response.data || errorMessage;
        console.log('Erro na resposta:', error.response);
      } else if (error.request) {
        console.log('Erro na requisição:', error.request);
      } else {
        console.log('Erro na configuração da requisição:', error.message);
      }

      toast.error(errorMessage);



    }

  };


  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Deseja confirmar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value);
      });
    });
  };





  return (
    <div >
      <FormContainer>
        <DivContainer ref={ref} >

          <InputArea>
            <Label>Lista atual:</Label>
            <Input
              value={colunaAtual.DESCRICAO_LISTA}
              readOnly
            />
          </InputArea>

          <InputArea>
            <Label>Mover para:</Label>
            <select
              name="id_coluna"

            >
              <option value="">Escolha </option>
              {colunasRestantes.map((user, index) => (
                <option key={index} value={user.ID_LISTA}>
                  {user.DESCRICAO_LISTA}
                </option>
              ))}
            </select>
          </InputArea>

          <InputArea>
            <div style={{ display: 'flex', flexDirection: 'column' }}>

              <Button onClick={() => handleSave()} type="button">
                Salvar
              </Button>
            </div>
          </InputArea>

        </DivContainer>


      </FormContainer>


      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div >

  );
};

export default Form;


